<template>
    <center>  
          <b-row class="justify-content-center"> 
             <b-col cols="11" md="7" lg="11" xl="11"> 
                <template> 
                    <center> 
                        <b-row class="justify-content-center">
                            <b-col cols="10" md="5" >  
                                <b-row class="justify-content-center" style=" margin: 5px; margin-left: -10px;" v-if="user.canal == 1"> 
                                  <b-col cols="10" md="4" class="mt-5"> 
                                     <img src="elementos/retails/lider.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:115%; cursor:pointer;'"  @click="cambiaPerfilR1(3)">  
                                  </b-col>   
                                </b-row>  
                                <b-row class="justify-content-center" style=" margin: 5px; margin-left: -10px;" v-if="user.canal == 4">
                                  <b-col cols="10" md="4" class="mt-5">  
                                    <img src="elementos/especialista/distribuidores.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'" @click="cambiaPerfilE1(1)"> 
                                  </b-col>
                                  <b-col cols="10" md="4" class="mt-5">  
                                    <img src="elementos/especialista/kams.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'" @click="cambiaPerfilE1(2)"> 
                                  </b-col>
                                  <b-col cols="10" md="4" class="mt-5"> 
                                     <img src="elementos/especialista/lider_e.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'"  @click="cambiaPerfilE1(3)">  
                                  </b-col>   
                                </b-row> 
                                <b-row class="justify-content-center" style=" margin: 5px; margin-left: -10px;" v-if="user.canal == 3">
                                  <b-col cols="10" md="4" class="mt-5">  
                                    <img src="elementos/propios/ejecutivo.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'" @click="cambiaPerfilP1(1)"> 
                                  </b-col>
                                  <b-col cols="10" md="4" class="mt-5">  
                                    <img src="elementos/propios/gerente.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'" @click="cambiaPerfilP1(2)"> 
                                  </b-col>
                                  <b-col cols="10" md="4" class="mt-5"> 
                                     <img src="elementos/propios/lider.png" class="rounded" alt="Image" :style="isMobile ? 'width:110%;' : 'width:105%; cursor:pointer;'"  @click="cambiaPerfilP1(3)">  
                                  </b-col>   
                                </b-row> 
                            </b-col> 
                        </b-row>
                        
                        <template v-if="menu_base > 0">
                         <br> <br v-if="!isMobile">
                          <template v-if="base_sub != ''" >
                            <template v-if="isMobile">
                              <img :src="'bases/propios/' + base_sub + '_movil.png'" class="rounded mt-5" alt="Image"  style="width:100%;" >
                            </template>
                            <template v-else>
                              <img :src="'bases/propios/' + base_sub + '.png'" class="rounded mt-5" alt="Image"  >
                            </template> 
                             <template v-if="isMobile"> 
                              <br>
                              <img src="img/rifado.png" class="rounded mt-5"  alt="Image" style="width:95%; "> <br>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="isMobile">
                              <img :src="'bases/propios/imagen_vacia_movil.png'" class="rounded mt-5" alt="Image"  style="width:100%;" >
                            </template>
                            <template v-else>
                              <img :src="'bases/propios/imagen_vacia.png'" class="rounded mt-5" alt="Image"  >
                            </template>  
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="isMobile">  
                            <div data-aos="flip-left" data-aos-delay="350"     data-aos-duration="800">
                              <img src="img/rifados_1.png" class="rounded"  alt="Image" style="width:100%; "><br> 
                            </div> 
                            <div data-aos="zoom-in" data-aos-delay="650"     data-aos-duration="700" >
                              <img src="img/orgullomexa.png" class="rounded"  alt="Image" style="width:95%; margin-top: -135px;"> 
                            </div>
                            <br v-if="isMobile"> <br v-if="isMobile">
                          </template>
                          <template v-else>   
                            <div data-aos="flip-left" data-aos-delay="350"     data-aos-duration="800">
                              <img src="img/rifados_1.png" class="rounded"  alt="Image" style="width:50%; "><br> 
                            </div> 
                            <div data-aos="zoom-in" data-aos-delay="650"     data-aos-duration="700" >
                              <img src="img/orgullomexa.png" class="rounded"  alt="Image" style="width:35%; margin-top: -115px;"> 
                            </div>
                          </template> 
                        </template>
                    </center> 
                      <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:55px; margin-top:-250px;" v-if="!isMobile"> 
                      <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:1455px; margin-top:-650px;" v-if="!isMobile">  
                      <img src="img/estrella.webp" class="rounded zoom-in-out-box"  alt="Image" style="width:4%; margin-left:1225px; margin-top:-50px;" v-if="!isMobile">   
                </template> 
             </b-col>
          </b-row>
        </center>
</template>
<script>
export default {
  name: 'Bases', 
  data(){
     return{
         menu_base:0,
         base_sub:"",
         isMobile: this.$mobile(),
     }
  },
 computed: {
    user() {
      return this.$store.getters.getInfoUser;
    }
  },
  methods:{
    cambiaPerfilR1(id){
      this.menu_base = id; 
      this.base_sub = 'retail_lider6';  
      this.apibitacora(1);
      this.$bus.$emit("cambi_fo6", true)
    },
    cambiaPerfilE1(id){
      this.menu_base = id; 
      if (id == 1) {
        this.base_sub = 'especialista_distribuidor6';  
        this.apibitacora(2);
      }else if(id == 2){
        this.base_sub = 'especialista_kams6';  
        this.apibitacora(3);
      }else{
        this.base_sub = 'especialista_lider6';  
        this.apibitacora(4);
      }
      
      this.$bus.$emit("cambi_fo6", true)
    },
    cambiaPerfilP1(id){
      this.menu_base = id; 
      if (id == 1) {
        this.base_sub = 'propio_ejecutivo6';  
        this.apibitacora(5);
      }else if(id == 2){
        this.base_sub = 'propio_gerente6';  
        this.apibitacora(6);
      }else{
        this.base_sub = 'propio_lider6'; 
        this.apibitacora(7); 
      }
      
      this.$bus.$emit("cambi_fo6", true)
    },
    apibitacora(id){
      var seccion = "";
      switch (id) {
        case 1:
          seccion = 'Líderes - Retail';
        break; 
        case 2:
          seccion = 'Distribuidor - Especialista';
        break;
        case 3:
          seccion = 'KAMs - Especialista';
        break;
        case 4:
          seccion = 'Líderes - Especialista';
        break;
        case 5:
          seccion = 'Ejecutivos - Propio';
        break;
        case 6:
          seccion = 'Gerente - Propio';
        break;
        case 7:
          seccion = 'Líder - Propio';
        break; 
      }
     this.$api.post('auth/bitacora', {
          'correo' : this.user.email,
          'mrt' : this.user.mrt,
          'canal' : this.user.canal,
          'perfil' : "",
          'region' : 'N/A',
          'url' : "/Bases",
          'seccion' : "",
          'accion' : 'Consulto',
          'detalle' :  'Consulto las bases ' + seccion,
        }).then(
          response => {
             console.log(response);
          })
    },
  },
  mounted(){ 
     window.AOS.init({
      // offset: 20,
      duration: 500,
      easing: 'ease-in-sine',
      delay: 300,
      anchorPlacement:'top-bottom', 
    });  
  }
}
</script>